import React from 'react';

const HorizontalSeparator = () => {
  return ( 
	<hr className="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700"></hr>
	)
};

export default HorizontalSeparator;
